import React from "react";
import { SelectType } from "./views";

export const Type: React.FC = () => {
  return (
    <React.Fragment>
      <SelectType />
    </React.Fragment>
  );
};
